import React from 'react';
import { TKlarityProgramItem, TMedication } from 'types/common';
import { getProviderMedicationList } from 'api/common';
import { getOpsProviderMedicationList } from 'api/operation';

let globalData: TMedication[] = [];

const useProviderMedication = (isOps?: boolean, providerId?: number): [TMedication[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TMedication[]>(globalData);
    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            let result: any;
            if (isOps && providerId) {
                result = await getOpsProviderMedicationList(providerId);
            } else {
                result = await getProviderMedicationList();
            }
            if (!result.error) {
                const resData = result?.data?.data || [];
                globalData = resData;
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useProviderMedication;
